import { InjectionToken } from "@angular/core";
import { HttpInterceptor, HttpContextToken } from "@angular/common/http";

/**
 * Injection token for the pcs client base API path
 */
export const BASE_PATH_PCS = new InjectionToken<string>('BASE_PATH_PCS', {
    providedIn: 'root',
    factory: () => '/api', // Default fallback
});
/**
 * Injection token for the pcs client HTTP interceptor instances
 */
export const HTTP_INTERCEPTORS_PCS = new InjectionToken<HttpInterceptor[]>('HTTP_INTERCEPTORS_PCS', {
    providedIn: 'root',
    factory: () => [], // Default empty array
});
/**
 * HttpContext token to identify requests belonging to the pcs client
 */
export const CLIENT_CONTEXT_TOKEN_PCS = new HttpContextToken<string>(() => 'pcs');
